import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { MacroNote } from '../../types/entities';

import { MacroNoteState, initialState } from './state';

const macroNoteSlice = createSlice({
  name: 'macro-note',
  initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: MacroNoteState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    success: (state: MacroNoteState, action: PayloadAction<MacroNote[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.notes = action.payload;
    },
    fail: (state: MacroNoteState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.notes = [];
    },
    add: (state: MacroNoteState, action: PayloadAction<MacroNote>) => {
      state.notes.push(action.payload);
      state.loading = false;
      state.loaded = true;
    },
    update: (state: MacroNoteState, action: PayloadAction<MacroNote>) => {
      const dbEntry = state.notes.find((x) => x.id === action.payload.id);
      if (!!dbEntry) {
        const index = state.notes.indexOf(dbEntry);
        state.notes[index] = action.payload;
      }
      state.loading = false;
      state.loaded = true;
    },
    remove: (state: MacroNoteState, action: PayloadAction<MacroNote>) => {
      const dbEntry = state.notes.find((x) => x.id === action.payload.id);
      if (!!dbEntry) {
        const index = state.notes.indexOf(dbEntry);
        state.notes.splice(index, 1);
      }
      state.loading = false;
      state.loaded = true;
    }
  }
});

const { actions, reducer } = macroNoteSlice;
export const { reset, loading, success, fail, add, update, remove } = actions;
export default reducer;
